import React from "react";
import { Container, Typography, Box } from "@mui/material";
import  imgEbn  from '../Images/LogoEBNLogin.png';
const ComingSoon = () => {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
       <Box
              component={"img"}
              src={imgEbn}
              sx={{  height: '20%', borderRadius: '8px',}}
            />
      <Box sx={{ p: 4, borderRadius: "12px" }}>

           
        <Typography variant="h2"  sx={{ mb: 2 ,color: 'rgb(12, 89, 167)'}} gutterBottom>
          Bientôt Disponible
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Nous travaillons dur pour apporter quelque chose d'incroyable. Restez à l'écoute !
        </Typography>
      </Box>
    </Container>
  );
};

export default ComingSoon;